var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9279 -8200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9279 8200)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12280.867 9541.455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3009.868-1323.44q0-4.225,0-8.449a2.888,2.888,0,0,1,3.014-3.006q6.994-.005,13.988,0a2.906,2.906,0,0,1,3.019,3.01q0,8.449,0,16.9a2.839,2.839,0,0,1-2.98,2.976h-14.068a2.826,2.826,0,0,1-2.972-2.98Q3009.865-1319.216,3009.868-1323.44Zm2.078-.007q0,4.184,0,8.368c0,.76.216.981.96.981h13.947c.729,0,.939-.212.939-.956q0-8.368,0-16.736c0-.787-.2-.981-.995-.981H3012.93c-.778,0-.984.208-.984,1Q3011.945-1327.612,3011.946-1323.447Z",
    transform: "translate(0 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3113.357-1203.908q1.574,0,3.148,0a.977.977,0,0,1,1.1.989.99.99,0,0,1-1.076,1.065q-3.168.013-6.337,0a1.009,1.009,0,0,1-1.083-1.063.989.989,0,0,1,1.1-.992Z",
    transform: "translate(-91.333 -123.434)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3113.345-1130.132q-1.591,0-3.182,0a.982.982,0,0,1-1.059-.948.992.992,0,0,1,1-1.1q3.242-.024,6.484,0a.97.97,0,0,1,1.015,1.074.975.975,0,0,1-1.071.976C3115.466-1130.131,3114.406-1130.132,3113.345-1130.132Z",
    transform: "translate(-91.325 -189.431)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3055.956-1205.867c-.212,0-.424,0-.635,0-.465,0-.7-.184-.73-.642a10.565,10.565,0,0,1,0-1.428c.033-.483.267-.675.754-.683.449-.007.9-.013,1.35,0,.432.015.653.2.673.626.026.54,0,1.084-.024,1.625a.5.5,0,0,1-.556.5C3056.513-1205.864,3056.234-1205.868,3055.956-1205.867Z",
    transform: "translate(-41.138 -119.091)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3055.967-1133.491c-.185,0-.371,0-.556,0-.571-.007-.807-.214-.832-.775-.019-.423-.021-.848,0-1.271.025-.506.252-.707.75-.709.45,0,.9,0,1.351,0,.471,0,.642.131.675.589a12.266,12.266,0,0,1,.017,1.507c-.022.449-.241.634-.69.655C3056.444-1133.482,3056.205-1133.492,3055.967-1133.491Z",
    transform: "translate(-41.134 -185.702)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPn);
export default __webpack_public_path__ + "static/media/icon-pn.ef7c8b3e.svg";
export { ForwardRef as ReactComponent };